// Phone country code (digits only, no plus sign) of a country, read from the
// `phonePrefix` of the countries catalog (e.g. '+54' -> '54'). When the country
// has no usable prefix it keeps the rule that existed before the catalog was
// read: '56' for Chile and '51' for any other country.
export function phoneCountryCodeFromPrefix(phonePrefix, iso) {
  const digits = typeof phonePrefix === 'string' ? phonePrefix.replace(/\D/g, '') : '';
  if (digits) return digits;
  return iso === 'CL' ? '56' : '51';
}
